import { InputNumber, InputNumberProps } from 'antd';

const CashInput = ({ ...props }: InputNumberProps) => (
  <InputNumber {...props} min={0} precision={0} step={1} type="number" size="large" placeholder="0" />
);

export default CashInput;
